/*
  ATD - Delivery Info 1
  Calcula la fecha estimada de entrega en el cliente:
  - Toma "hoy" en la hora local del navegador.
  - Si la hora actual >= cutoff_hour, suma 1 día (pedido pasa al siguiente día).
  - Suma max_business_days saltando fines de semana (si skip_weekends está activo).
  - Formatea como "DDD DD MMM" en el locale configurado (es-MX por default).
*/
(function () {
  const targets = document.querySelectorAll('[data-atd-delivery-target]');
  if (!targets.length) return;

  const addBusinessDays = (date, days, skipWeekends) => {
    const d = new Date(date);
    if (!skipWeekends) {
      d.setDate(d.getDate() + days);
      return d;
    }
    let added = 0;
    while (added < days) {
      d.setDate(d.getDate() + 1);
      const dayOfWeek = d.getDay(); // 0 = domingo, 6 = sábado
      if (dayOfWeek !== 0 && dayOfWeek !== 6) {
        added += 1;
      }
    }
    return d;
  };

  const formatDate = (date, locale) => {
    // Formato deseado: "JUE 28 MAY" (día semana abreviado + número + mes abreviado, todo MAYÚSCULA)
    try {
      const weekday = new Intl.DateTimeFormat(locale, { weekday: 'short' }).format(date);
      const day = new Intl.DateTimeFormat(locale, { day: '2-digit' }).format(date);
      const month = new Intl.DateTimeFormat(locale, { month: 'short' }).format(date);
      // .replace para limpiar puntos que algunos locales agregan ("may." → "may")
      const cleanWeekday = weekday.replace(/\./g, '').trim();
      const cleanMonth = month.replace(/\./g, '').trim();
      return `${cleanWeekday.toUpperCase()} ${day} ${cleanMonth.toUpperCase()}`;
    } catch (e) {
      // Fallback si el navegador no soporta Intl con ese locale
      return date.toDateString();
    }
  };

  targets.forEach((target) => {
    const minDays = parseInt(target.dataset.minDays, 10) || 3;
    const maxDays = parseInt(target.dataset.maxDays, 10) || 5;
    const cutoffHour = parseInt(target.dataset.cutoffHour, 10);
    const skipWeekends = target.dataset.skipWeekends === 'true';
    const prefix = target.dataset.prefix || 'Llega el';
    const locale = target.dataset.locale || 'es-MX';

    const now = new Date();
    const base = new Date(now);

    // Si pasó el cutoff hour, el pedido se procesa "mañana" → base += 1 día
    if (!Number.isNaN(cutoffHour) && now.getHours() >= cutoffHour) {
      base.setDate(base.getDate() + 1);
    }

    // Usamos max_business_days (escenario más conservador para el cliente)
    const deliveryDate = addBusinessDays(base, maxDays, skipWeekends);
    const formatted = formatDate(deliveryDate, locale);

    target.innerHTML = `${prefix} <strong>${formatted}</strong>`;
  });
})();
